import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import ReactTable from "react-table";
import Translate from 'translate';
import { withGoogleMap, GoogleMap, Marker,withScriptjs } from "react-google-maps"



class GMap extends React.Component {

  constructor( props ) {
    super( props );

  }
  shouldComponentUpdate(nextProps, nextState) {
    const {lat, lng, addMarker, handleZoom, defaultZoom} = this.props;
    console.log(nextProps)

    if ( (lat !== nextProps.lat) || (lng !== nextProps.lng) || (defaultZoom !== nextProps.defaultZoom) ){
      return true;
    } else {
      return false;
    }
    
  }
  handleZoomChanged = (e) => {
    const {lat, lng, addMarker, handleZoom, defaultZoom} = this.props;
    console.log( "ZOMM ",e);
    
    
  } 
  render() {
    const {lat, lng, addMarker, handleZoom, defaultZoom} = this.props;
    return (
    <GoogleMap
    onClick={addMarker}
    defaultZoom={defaultZoom}
    defaultCenter={{ lat: lat, lng: lng }}
    onZoomChanged={this.handleZoomChanged}
    >
    <Marker position={{ lat: lat, lng: lng}} />
    </GoogleMap>
    
    )
  }
}

module.exports =withScriptjs( withGoogleMap(GMap)) ;



// WEBPACK FOOTER //
// ./routes/app/components/Agent/WorkRequest/GMap/index.js